import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    container: {
        position: 'fixed',
        bottom: 120,
        right: 20,
        zIndex: 9999,
        animation: '$slideIn 0.3s ease-out',
    },
    '@keyframes slideIn': {
        from: {
            transform: 'translateX(400px)',
            opacity: 0,
        },
        to: {
            transform: 'translateX(0)',
            opacity: 1,
        },
    },
    notification: {
        background: 'linear-gradient(135deg, #fff8e1 0%, #fff3e0 100%)',
        borderLeft: '4px solid #ff9800',
        borderRadius: 8,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        padding: '16px 20px',
        minWidth: 320,
        maxWidth: 400,
        position: 'relative',
    },
    closeButton: {
        position: 'absolute',
        top: 8,
        right: 8,
        background: 'transparent',
        border: 'none',
        fontSize: 24,
        color: '#999',
        cursor: 'pointer',
        padding: 0,
        width: 24,
        height: 24,
        lineHeight: '20px',
        transition: 'color 0.2s',
        '&:hover': {
            color: '#333',
        },
    },
    content: {
        display: 'flex',
        gap: 12,
        alignItems: 'flex-start',
    },
    icon: {
        fontSize: 28,
        flexShrink: 0,
    },
    text: {
        flex: 1,
    },
    title: {
        color: '#333',
        fontSize: 16,
        display: 'block',
        marginBottom: 4,
    },
    message: {
        color: '#666',
        fontSize: 14,
        margin: '0 0 8px 0',
    },
    link: {
        color: '#1976d2',
        textDecoration: 'none',
        fontSize: 14,
        fontWeight: 500,
        display: 'inline-block',
        transition: 'color 0.2s',
        '&:hover': {
            color: '#1565c0',
            textDecoration: 'underline',
        },
    },
}));

export default useStyles;
